const mixtureReducer = (state = null, action) => {
  switch (action.type) {
    case 'MIXTURE_POPUP_SET': return action.payload;
    case 'MIXTURE_POPUP_CLOSE': return null;
    default: return state;
  }
};

export default mixtureReducer;
